// extracted by mini-css-extract-plugin
export var columnList = "_bh-0";